import { Injectable } from '@angular/core';
import { ConnectorCode } from '@eemo/api-client';

@Injectable({ providedIn: 'root' })
export class ConnectornHelper {
  constructor() {}

  getConnectorLogo(connectorCode: ConnectorCode): string {
    return 'assets/images/' + this.getConnectorLogoFilename(connectorCode) + '.png';
  }

  getConnectorLogo2x(connectorCode: ConnectorCode): string {
    return 'assets/images/' + this.getConnectorLogoFilename(connectorCode) + '@2x.png';
  }

  private getConnectorLogoFilename(connectorCode: ConnectorCode): string {
    switch (connectorCode) {
      case 'KWFRANCE':
        return 'logo_kw';
      default:
        return 'no_logo';
    }
  }

  getConnectorDisplayName(connectorCode: ConnectorCode): string {
    switch (connectorCode) {
      case 'KWFRANCE':
        return 'My KW';
      default:
        return 'inconnu';
    }
  }
}
